import { withTranslation } from "react-i18next";

import AgentListReports from './AgentListReports';

export default withTranslation(undefined, { withRef: true })(AgentListReports);